import { useCallback } from 'react';
import { useLazyGetCollectionImageMetaDataQuery } from '@/store/api';
/**
 * Platform-services lazy-query hook for fetching collection image metadata on demand.
 *
 * Wraps the RTK Query `useLazyGetCollectionImageMetaDataQuery` hook.
 * Use when the collection name is not known at mount time.
 *
 * @see src/store/api/cc/collectionsApi.ts
 */
export const useLazyGetCollectionImageMetaData = () => {
    const [trigger, { data, isLoading, isFetching, isError, error, }] = useLazyGetCollectionImageMetaDataQuery();
    const triggerGetCollectionImageMetaData = useCallback((collectionName) => trigger({ collectionName }).unwrap(), [trigger]);
    return {
        triggerGetCollectionImageMetaData,
        data,
        isLoading: isLoading || isFetching,
        isError,
        error,
    };
};
